import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import { fromAnyDateToZuluDayBgn, fromAnyDateToZuluDayEnd } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('beCashupVoucher'); // eslint-disable-line no-unused-vars

const fromDtoToRaw = void 1; // for printing in console, you can use: L.wrap('fromDtoToRaw()', alwaysSame);

// SEE: https://getslick.atlassian.net/browse/GS-13449

// transactions.api: GET /cashup/:salonId/vouchers/filter/  → replaces old: /cashup/:salonId/vouchers
// transactions.api: GET /cashup/:salonId/vouchers/personal/ -> replaces old: /cashup/:salonId/vouchers

const MISSING = 'Missing one or more of the required parameters';

const reconfigure = (config) => (options, extra) => {
  const perm = extra?.filter ? 'filter' : 'personal';

  const bgn = fromAnyDateToZuluDayBgn(extra?.bgn) || null;
  const end = fromAnyDateToZuluDayEnd(extra?.end) || null;

  const params = { bgn, end, perm };

  if (!perm) L.warn('reconfigure()', options?.name, MISSING, params, 'for', { config, options, extra });

  return {
    ...options,
    ...config,
    base: CONF.transactionApiRoot,
    fromDto: fromDtoToRaw,
    params,
  };
};

export const ibeCashupVouchersRead = actionEndpointBe('ibeCashupVouchersRead', H.get, 'cashup/:salonId/vouchers/:perm/?start=:bgn?&end=:end?', reconfigure({ inert: true }));

export const abeCashupVouchersRead = actionEndpointBe('abeCashupVouchersRead', H.get, 'cashup/:salonId/vouchers/:perm/?start=:bgn?&end=:end?', reconfigure({ inert: false }));
